module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7bd7487b704797cb5ab3cb441486ea70.svg";